module.exports = __webpack_public_path__ + "DINNextLTPro-Heavy.woff2?bdd4577fb7f57d77652ebbb8e2fc03d7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Heavy.woff2
// module id = 1409
// module chunks = 0